var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userBox"},[_c('h2',{staticClass:"user"},[_vm._v(_vm._s(_vm.userInfo.name)+"，"+_vm._s(_vm.getTimeState()))])])}
var staticRenderFns = []

export { render, staticRenderFns }